import React from 'react';
import { AccordionBodyItemView } from 'component/Accordion';
import { isLegacyContaminationView } from 'utils/HaReportFormVersion';

export const DescriptionView = (props) => {
  const {
    formData,
    translatedFormData,
    translateState,
  } = props;

  const useLegacyView = isLegacyContaminationView(formData);

  return (
    <AccordionBodyItemView
      accordionSubId={useLegacyView ? '3.9' : '3.11'}
      titleUA="Опис типу забруднення (за потреби)"
      titleEN="Description of the type of contamination"
      children={(
        <>
          {translateState && translatedFormData.hazard_type_description}
          {!translateState && formData.info.hazard_type.description}
        </>
      )}
    />
  );
};
